/**
 * Array of all content namespaces. The naming convention of namespaces is identical to the contentFile.ts in src/content
 * This list is used in App.tsx to load pre-fetch content files on app load to prevent content flicker
 */
export const namespaces = [
  "academy",
  "footer",
  "actionReports",
  "actionReportsBirthdays",
  "actionReportsFsiTracking",
  "actionReportsIboOnboarding",
  "actionReportsRenewals",
  "actionReportsWhosClose",
  "actionReportsWhosNew",
  "annualPGG",
  "annualGcrPGGV2",
  "awardLabels",
  "bronzeBuilder",
  "bronzeFoundation",
  "businessSelector",
  "bsmSubmissionForm",
  "csi",
  "downlineProfile",
  "earningsCalculator",
  "edlos",
  "frontlineGrowth",
  "monthlyPGG",
  "monthlyPerformanceDashboard",
  "navigation",
  "ppe",
  "provideUsFeedback",
  "smartNextSteps",
  "ssiUplineReport",
  "ttci",
  "watchlist",
  "faa",
  "hat",
  "regulationInfoBanner",
  "foundersPlatinumProgressTile",
  "awardProgressBadge",
  "leafAboName",
  "leafFilter",
  "newAboActivation",
  "volumeRequirementTile",
  "vcsRequirementTile",
  "fggMultiplierDetails",
  "IncentiveCalculationLevels",
  "profile",
  "groupManagement",
  "performanceIncomeDashboard",
  "monthlyPerformanceTotalModals",
  "rubyBonusModal",
  "keyMetrics",
  "leafPerfBonusScale",
  "profileSelectorDropdown",
  "impersonationBanner",
  "onlineStatements",
  "qGrowthIncentive",
  "retroPvInquiry",
  "common",
  "customers",
  "errorTile",
  "vcsReasons",
  "leafErrorMessage",
  "leafSortInfo",
  "downlineProfile",
  "foundersSalesIncentive",
  "watchlistNotifications",
  "growthOrMaintainFQWithGPV",
  "groupVolumeRequirementTile",
  "groupVolumeBaselineModal",
  "leaderIncentive",
];
